import clsx from 'clsx'

// repeat_week_days according to user request: 0=Sun, 1=Mon, 2=Tue, 3=Wed, 4=Thu, 5=Fri, 6=Sat
const DAYS = [
  { value: 0, label: '日' },
  { value: 1, label: '月' },
  { value: 2, label: '火' },
  { value: 3, label: '水' },
  { value: 4, label: '木' },
  { value: 5, label: '金' },
  { value: 6, label: '土' }
]

type Props = {
  value?: number[]
  onChange?: (val: number[]) => void
  disabled?: boolean
}

export default function WeekDayPicker({
  value = [],
  onChange,
  disabled = false
}: Props) {
  const toggle = (day: number) => {
    if (!onChange || disabled) return
    if (value.includes(day)) {
      onChange(value.filter((d) => d !== day))
    } else {
      onChange([...value, day])
    }
  }

  return (
    <div className="flex gap-2 flex-wrap">
      {DAYS.map((d) => {
        const selected = value.includes(d.value)
        return (
          <button
            key={d.value}
            type="button"
            disabled={disabled}
            onClick={() => toggle(d.value)}
            className={[
              'w-9 h-9 rounded-full text-sm font-medium border transition-colors',
              disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer',
              selected
                ? 'bg-[#3451D1] text-white border-[#3451D1]'
                : clsx(
                    'bg-white text-[#3451D1] border-[#3451D1]',
                    !disabled && 'hover:bg-blue-50'
                  )
            ].join(' ')}
          >
            {d.label}
          </button>
        )
      })}
    </div>
  )
}

WeekDayPicker.defaultProps = {
  value: [],
  onChange: undefined,
  disabled: false
}
